import { Action, createSelector, Selector, State, StateContext } from '@ngxs/store';
import {
    SharedListingResetAction,
    SharedListingSaveAction
} from 'src/app/_shared/stores/listing/shared-listing.actions';
import { KalTablePageEvent, KalTableSortEvent } from 'src/app/_shared/modules/kal-table/kal-table.module';
import { Injectable } from '@angular/core';

export class SharedListingData<F = any> {
    filters?: F;
    page?: KalTablePageEvent;
    sort?: KalTableSortEvent;
}

export class SharedListingStateModel<F = any> {
    [key: string]: SharedListingData<F>;
}

@Injectable()
@State<SharedListingStateModel>({
    name: 'sharedListing',
    defaults: new SharedListingStateModel()
})
export class SharedListingState {

    @Selector()
    static informations(listingId: string) {
        return createSelector([], (state: { sharedListing: SharedListingStateModel }): SharedListingData => {
                return state?.sharedListing?.[listingId] || {};
            }
        );
    }

    @Action(SharedListingSaveAction)
    save({patchState, getState}: StateContext<SharedListingStateModel>, {
        listingId,
        informations
    }: SharedListingSaveAction) {
        const state = getState();
        const {filters, sort, page} = state?.listingId || {
            filters: undefined,
            sort: undefined,
            page: {size: 50, number: 0}
        };
        patchState({
            [listingId]: {
                filters: informations.filters || filters,
                sort: informations.sort || sort,
                page: informations.page || page,
            }
        });
    }

    @Action(SharedListingResetAction)
    reset({patchState}: StateContext<SharedListingStateModel>, {listingId}: SharedListingResetAction) {
        patchState({
            [listingId]: {
                filters: undefined, sort: undefined
            }
        });
    }

}
